if (Promise.prototype.finally == null) {
    Promise.prototype.finally = function (handler) {
        return this.then(handler, handler);
    }
}

Number.prototype.number_format = function(n, c,s) {
    var x =3;
    /**
    https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-currency-string-in-javascript
    * Number.prototype.format(n, x, s, c)
    *
    * @param integer n: length of decimal
    * @param integer x: length of whole part
    * @param mixed   s: sections delimiter
    * @param mixed   c: decimal delimiter
    */
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
    num = this.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

String.prototype.slug = function() {
    return this
        .toLowerCase()
        .replace(/[^\w\s]+/g,'')
        .replace(/\s+/g,'-');
};

String.prototype.isNumeric = function() {
    return !isNaN(this);
};
Number.prototype.isNumeric = function() {
    return true;
};
$.fn.isInViewport = function() {
    if (!$(this).length) return;
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$.fn.serializeObject = function() {
    let o = {};
    let a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};